export const WINAPP_METHOD = {
    AGENDA: {
        OPEN_APPOINTMENT_DETAIL: "OPEN_APPOINTMENT_DETAIL",
        OPEN_PROPERTY_DETAIL: "OPEN_PROPERTY_DETAIL",
        NEW_APPOINTMENT: "OPEN_NEW_APPOINTMENT",
        CLOSE_CONFIRMATION: "CLOSE_CONFIRMATION"
    },
    PERSON: {
        OPEN_PERSON_EDIT: "OPEN_PERSON_EDIT"
    },
    PROPERTY: {
        LOGOUT_SOCIAL_MEDIA: "LOGOUT_SOCIAL_MEDIA",
        CLOSE_SOCIAL_MEDIA: "CLOSE_SOCIAL_MEDIA",
        PUBLISHING_SOCIAL_MEDIA: "PUBLISHING_SOCIAL_MEDIA",
        PUBLISHED_SOCIAL_MEDIA: "PUBLISHED_SOCIAL_MEDIA",
        CLOSE_SMOOVED: "CLOSE_SMOOVED",
        TRANSLATION_MODAL: "CLOSE_TRANSLATION_MODAL",
        SMOOVED_CLOSE_MODAL: "SMOOVED_CLOSE_MODAL",
        LOAD_PROPERTY: "LOAD_PROPERTY",
        GENERATE_TITLE_RESPONSE: "GENERATE_TITLE_RESPONSE",
        CLOSE_GENERATE_TITLE: "CLOSE_GENERATE_TITLE",
        GENERATE_DESCRIPTION_RESPONSE: "GENERATE_DESCRIPTION_RESPONSE",
        CLOSE_GENERATE_DESCRIPTION: "CLOSE_GENERATE_DESCRIPTION",
        VIDEO_MANAGEMENT_SELECTED: "VIDEO_MANAGEMENT_SELECTED",
        CLOSE_SEND_INVOICE: "CLOSE_SEND_INVOICE",
        OPEN_PROPERTY_EDIT: "OPEN_PROPERTY_EDIT"
    },
    BROCHURE: {
        CLOSE_BROCHURE: "CLOSE_BROCHURE"
    },
    REPORT: {
        SMS: {
            CLOSE_SMS_MESSAGE: "CLOSE_SMS_MESSAGE",
            LOADED_SMS_MESSAGE: "LOADED_SMS_MESSAGE"
        }
    }
};
